import _ from 'lodash';

import { useMemo, useState } from 'react';
import { useHubAgenda } from '../../../../store/hub/useHubAgenda';
import { useQueryParam } from 'use-query-params';

import { HeatMapColor } from './HeatMapColor';
import { getDay } from '../../../../services/functions';

export function HeatMap() {
  const [active] = useQueryParam("date");

  const agendaHeatMap = useHubAgenda(state => state.data.heatMap)
  const hours = useHubAgenda(state => state.data.hours)
  const heatMapShowDates = useHubAgenda(state => state.data.heatMapDates)
  const heatMapDates = useMemo(() => _.pick(agendaHeatMap, heatMapShowDates), [heatMapShowDates, agendaHeatMap])


  const [colHover, setColHover] = useState(null);
  const [rowHover, setRowHover] = useState(null);

  const current = getDay(active).format('YYYY-MM-DD')

  return (
    <div className="w-full h-full">
      <div className="flex flex-col flex-1 w-full h-full group/content">
        <div className="flex w-full h-8">
          <div className="w-16" />
          {Object.entries(heatMapDates).map(([date, props]) => (
            <div
              key={date}
              onMouseOver={() => setColHover(date)}
              onMouseLeave={() => setColHover(null)}
              data-active={current === date}
              className="flex flex-1 items-center justify-center border-b text-zinc-500 border-b-zinc-700 text-xs font-semibold data-[active=true]:text-orange-500 data-[active=true]:font-bold "
            >
              {props.weekDay}
            </div>
          ))}
        </div>
        <div className="flex flex-1 flex-col relative">
          {hours.map((hour, row) => (
            <div
              key={hour}
              onMouseOver={() => setRowHover(hour)}
              onMouseLeave={() => setRowHover(null)}
              data-row={rowHover === hour}
              className="flex w-full flex-1 group/row"
            >
              <div className="group/cell w-16 group-hover/content:opacity-60 flex items-center justify-center border-r text-zinc-500 border-r-zinc-700 text-xs">
                {hour}
              </div>
              {Object.entries(heatMapDates).map(([date, props], column) => (
                <div
                  key={date}
                  onMouseOver={() => setColHover(date)}
                  onMouseLeave={() => setColHover(null)}
                  data-col={colHover === date}
                  data-row={rowHover === hour}
                  className="group/cell flex flex-1 items-center justify-center border-r border-b border-zinc-700 text-[10px]"
                >
                  <HeatMapColor row={row} column={column} props={props} hour={hour} />
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div >
  );
}
